import "@styles/react/libs/flatpickr/flatpickr.scss"
import { useParams } from "react-router-dom"
import RetiroInteligenteForm from "@pages/asesorias/forms/personales/RetiroInteligenteForm"
import PlanMedicoIndividualForm from "@pages/asesorias/forms/personales/PlanMedicoIndividualForm"
import EducacionGarantizadaForm from "@pages/asesorias/forms/personales/EducacionGarantizadaForm"
import ViajeSeguroForm from "@pages/asesorias/forms/personales/ViajeSeguroForm"
import HogarSeguroForm from "@pages/asesorias/forms/personales/HogarSeguroForm"
import AutoSeguroForm from "@pages/asesorias/forms/personales/AutoSeguroForm"
import LibertadFinancieraForm from "@pages/asesorias/forms/personales/LibertadFinancieraForm"

import ResponsabilidadCivilAbogadoForm      from "@pages/asesorias/forms/empresariales/ResponsabilidadCivilAbogadoForm"
import ResponsabilidadCivilConstruccionForm from "@pages/asesorias/forms/empresariales/ResponsabilidadCivilConstruccionForm"
import ResponsabilidadProfesinesMedicas     from "@pages/asesorias/forms/empresariales/ResponsabilidadProfesinesMedicasForm"

import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { useEffect, useState } from "react"
import { useAsesoria } from "../../../../utility/hooks/useAsesoria"
import ClienteForm from "./personales/ClienteForm"


const AsesoriasPublicasForm = (props) => {

const MySwal = withReactContent(Swal)

  const [enviado, setEnviado] = useState(false)
  const [tiposAsesorias, setTiposAsesorias] = useState([])
  const [tipoAsesoriaSeleccionada, setTipoAsesoriaSeleccionada] = useState()
  const [datosProspecto, setDatosProspecto] = useState({})

  function handleSuccess(value) {
    setEnviado(true)
    MySwal.fire({
      title: 'Asesoria guardada',
      text: 'La asesoria se ha guardado correctamente.',
      icon: "success",
      customClass: {
        confirmButton: "btn btn-primary"
      },
      buttonsStyling: false
    })
  }

  const hookAsesoria = useAsesoria({cliente:datosProspecto})
  const params = useParams()
  // const asesoriasForms = 

  
  const [asesoriasForms, setAsesoriasForms] = useState({
    "retiro-inteligente": 
      <RetiroInteligenteForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "plan-medico-individual": 
      <PlanMedicoIndividualForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "educacion-garantizada": 
      <EducacionGarantizadaForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "viajar-seguro": 
      <ViajeSeguroForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "auto-seguro": 
      <AutoSeguroForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "hogar-seguro": 
      <HogarSeguroForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "libertad-financiera": 
      <LibertadFinancieraForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "responsabilidad-civil-abogado":
      <ResponsabilidadCivilAbogadoForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
    "responsabilidad-civil-profesiones-medicas": 
      <ResponsabilidadProfesinesMedicas
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />,
      "responsabilidad-civil-construccion": 
      <ResponsabilidadCivilConstruccionForm
        accion={1}
        asesoria={params.asesoria}
        handleSuccess={handleSuccess}
        {...hookAsesoria}
      />
  })

  useEffect(() => {
    
    setAsesoriasForms({
      "retiro-inteligente": 
        <RetiroInteligenteForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "plan-medico-individual": 
        <PlanMedicoIndividualForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "educacion-garantizada": 
        <EducacionGarantizadaForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "viajar-seguro": 
        <ViajeSeguroForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "auto-seguro": 
        <AutoSeguroForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "hogar-seguro": 
        <HogarSeguroForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "libertad-financiera": 
        <LibertadFinancieraForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "responsabilidad-civil-abogado":
        <ResponsabilidadCivilAbogadoForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
      "responsabilidad-civil-profesiones-medicas": 
        <ResponsabilidadProfesinesMedicas
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />,
        "responsabilidad-civil-construccion": 
        <ResponsabilidadCivilConstruccionForm
          accion={1}
          asesoria={params.asesoria}
          handleSuccess={handleSuccess}
          {...hookAsesoria}
        />
    })
    if (tipoAsesoriaSeleccionada) {
      setFormActivo(asesoriasForms[tipoAsesoriaSeleccionada.slug])
    }
  }, [datosProspecto])

  return (
    <div>
    {
      enviado ? (
        <div className = "m-2">
          Asesoria guardada correctamente, el agente ha sido notificado y se comunicara en breve.
        </div >
      ) : (
        <div className = "m-2">          
            <ClienteForm 
              setdatosCliente={setDatosProspecto}
            />
            {asesoriasForms[params.asesoria]}
        </div >
      )
    }
    </div>
    
  )
}

export default AsesoriasPublicasForm
